export type RegionsDataT = {
  [color: string]: {
    points: [number, number][];
    borderPoints: [number, number][];
  };
};
export type ImageSegmentsDataT = {
  canvasContext: CanvasRenderingContext2D;
  regionsData: RegionsDataT;
};
export type SuperpixelImageRegionsDataT = {
  [key: number]: ImageSegmentsDataT;
};
export type SuperpixelImageT = {
  segmentCount: number;
  url: string;
};